export default __webpack_public_path__ + "static/media/X.40482dd7.svg";